<template>
  <div class="layout-info-wrapper">
    <p class="info" :class="infoType"> {{ title }} </p>
  </div>
</template>

<script>
export default {
  name: 'LayoutInfo',
  props: {
    title: String,
    infoType: String,
  },
};
</script>

<style lang="scss" scoped>
.layout-info-wrapper {
  width: 100%;
  height: auto;

  padding: 10px;
  background-color: rgb(255, 255, 255);

  border-radius: 10px;

  margin-top: 5px;
  margin-bottom: 5px;

  .info {
    width: 100%;

    padding: 0;
    margin: 0;

    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    &.warn {
      color: rgba(255, 0, 0, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutInfo.vue